import * as React from 'react';

import { Header, IconButton } from '@ixyberfree/ixybercomponents';
import { ContextMenu } from 'components/MainControl/Settings/components/ContextMenu/ContextMenu';
import { Modal } from 'components/MainControl/Settings/components/Modal/Modal';
import { observer } from 'mobx-react-lite';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { useStores } from '../../store';
import TreeAPC, { ITreeAPC_branch } from '../MainControl/TreeAPC/TreeAPC';
import { ICLFolder, ICMain } from './IConfiguration';
import FunctionPage from './libs/FunctionPage';
import TypePage from './libs/TypePage';

interface IPropsConfiguration {
    auth: {
        visibleAuth: boolean;
        authenticated: boolean;
        settingTrue: boolean;
        nameUser: string;
        callbackLogin: Function;
        callbackLogout: Function;
    };
}

const Wrapper = styled.div`
    background: #f8fafb;
    min-height: 100%;
    height: 100%;
    width: 100%;
    font-family: Roboto;
    position: relative;
`;

const Card = styled.div`
    background: #ffffff;
    box-shadow: 4px 4px 4px rgba(0, 0, 0, 0.05);
    margin: 1em;
    height: calc(100% - 4em);
    min-height: calc(100% - 4em);
    padding: 1.6em 2em;
    overflow: auto;
    display: 'flex';
    paddingright: 0;
`;

const Configuration: React.FC<IPropsConfiguration> = ({ auth }) => {
    const [resizeTree, setResizeTree] = React.useState<boolean>(false);
    const [widthWindowTree, setSidthWindowTree] = React.useState<number>(320);

    const [configMain, setConfigMain] = React.useState<ICMain>({ name: '' });

    const [treeBranch, setTreeBranch] = React.useState<ITreeAPC_branch[]>([]);

    const [selectElement, setSelectElement] = React.useState<{ page: string; id: string }>({ id: '', page: '' });

    const defContextMenu: { visible: boolean; position: { x: number; y: number }; elements: any } = {
        visible: false,
        elements: '',
        position: { x: 0, y: 0 }
    };
    const [contextMenu, setContextMenu] = React.useState(defContextMenu);

    const { ICLibStore } = useStores();

    const LoadConfigMain = () => {
        fetch('/ixyber/vision/file/configMain', {
            headers: { Accept: 'application/json', 'Content-Type': 'application/json' }
        })
            .then((res) => {
                return res.json();
            })
            .then((data) => {
                setConfigMain(JSON.parse(data));
            })
            .catch((errorData) => {
                console.error('Failed to load Data: ', errorData);
            });
    };

    React.useEffect(() => {
        LoadConfigMain();
        return () => {};
    }, []);

    React.useEffect(() => {
        UpdataTree();
        return () => {};
    }, [configMain, ICLibStore._configLib, selectElement]);

    const ConvertText = (txt: string): string => {
        let res: string;
        switch (txt) {
            case 'Libs':
                res = 'Библиотека';
                break;
            case 'itypes':
                res = 'Типы';
                break;
            case 'functions':
                res = 'Функции';
                break;
            case 'functionsBlock':
                res = 'Функциональные блоки';
                break;
            default:
                res = txt;
        }
        return res;
    };

    const GetChildITypes = (pbranch: ICLFolder): ITreeAPC_branch => {
        let branch: ITreeAPC_branch = {
            name: ConvertText(pbranch.name),
            class: 'ICLFolder',
            type: 'folder',
            children: []
        };

        for (let prop in pbranch.folders) {
            branch.children?.push(GetChildITypes(pbranch.folders[prop]));
        }

        return branch;
    };

    const FindFolder = (parent: ITreeAPC_branch, path: string): ITreeAPC_branch => {
        let res: ITreeAPC_branch = parent;
        if (path != null && path != '') {
            let name = path.split('/');
            if (name.length > 0) {
                res = parent.children?.find((f) => f.name == ConvertText(name[0])) || parent;
                if (name.length > 1) {
                    name.splice(0, 1);
                    res = FindFolder(res, name.join('/'));
                }
            }
        }
        return res;
    };

    const openContextMenu = (e: React.MouseEvent<Element, MouseEvent>, name: string) => {
        e.preventDefault();
        let posX = e.pageX;
        let posY = e.pageY;

        setContextMenu({ visible: true, position: { x: posX, y: posY }, elements: 'sdd' });
    };

    const UpdataTree = () => {
        let branch: ITreeAPC_branch = { name: configMain?.name, type: 'folder', class: '', children: [], title: 'sss' };

        let branchLib: ITreeAPC_branch = { name: ConvertText('Libs'), class: 'Libs', type: 'folder', children: [] };
        branch.children?.push(branchLib);

        ///Types
        let branchLibChild: ITreeAPC_branch = {
            name: ConvertText('itypes'),
            class: 'itypes',
            type: 'folder',
            children: []
        };
        branchLib.children?.push(branchLibChild);

        for (let prop in ICLibStore.configLib().itypes.folders) {
            branchLibChild.children?.push(GetChildITypes(ICLibStore.configLib().itypes.folders[prop]));
        }

        for (let prop in ICLibStore.configLib().itypes.variables) {
            let variable = ICLibStore.configLib().itypes.variables[prop];
            let f_parent = FindFolder(branchLibChild, variable.path);
            if (f_parent) {
                let icon = 'static/images/tree_icon/type_icon.svg';
                switch (variable.data.type) {
                    case 'array':
                        icon = 'static/images/tree_icon/Type_data_array.svg';
                        break;
                    case 'enum':
                        icon = 'static/images/tree_icon/Type_data_enum.svg';
                        break;
                    case 'struct':
                        icon = 'static/images/tree_icon/Type_data_struct.svg';
                        break;
                }

                f_parent.children?.push({
                    name: variable.name,
                    class: '',
                    type: 'file',
                    iconUrl: icon,
                    children: [],
                    clickCallBack: () => {
                        RenderTypePage(Number(prop));
                    },
                    contextCallBack: (e) => {
                        openContextMenu(e, variable.name);
                    }
                });
            }
        }

        ///Function
        let branchLibFunctionChild: ITreeAPC_branch = {
            name: ConvertText('functions'),
            class: '',
            type: 'folder',
            children: []
        };
        branchLib.children?.push(branchLibFunctionChild);

        for (let prop in ICLibStore.configLib().itypes.folders) {
            branchLibFunctionChild.children?.push(GetChildITypes(ICLibStore.configLib().functions.folders[prop]));
        }

        for (let prop in ICLibStore.configLib().functions.variables) {
            let variable = ICLibStore.configLib().functions.variables[prop];
            let f_parent = FindFolder(branchLibFunctionChild, variable.path);
            if (f_parent) {
                let icon = 'static/images/tree_icon/function.svg';

                f_parent.children?.push({
                    name: variable.name,
                    class: '',
                    type: 'file',
                    iconUrl: icon,
                    children: [],
                    clickCallBack: () => {
                        RenderFunctionPage(Number(prop));
                    },
                    contextCallBack: (e) => {
                        openContextMenu(e, variable.name);
                    }
                });
            }
        }

        setTreeBranch([branch]);
    };

    const RenderFunctionPage = (prop: number) => {
        let data_type = ICLibStore.configLib().functions.variables[prop];
        if (data_type) {
            setSelectElement({ page: 'function', id: prop.toString() });
        }
    };

    const RenderTypePage = (prop: number) => {
        let data_type = ICLibStore.configLib().itypes.variables[prop];
        if (data_type) {
            setSelectElement({ page: 'type', id: prop.toString() });
        }
    };

    const resizeWidthWindow = (e: React.MouseEvent) => {
        let width: number = e.pageX;
        if (resizeTree) {
            setSidthWindowTree(width);
        }
    };

    const renderPage = () => {
        switch (selectElement.page) {
            case 'type':
                return <TypePage num_type={Number(selectElement.id)} />;
            case 'function':
                return <FunctionPage num_type={Number(selectElement.id)} />;
            default:
                return '';
        }
    };

    return (
        <React.Fragment>
            <Wrapper
                onMouseUp={(e) => {
                    setResizeTree(false);
                }}
                onMouseMove={(e) => {
                    resizeWidthWindow(e);
                }}>
                <Header
                    homeElement={
                        <Link to={'/ixyber/vision/display/base'} title="Главная">
                            <IconButton imageUrl="Home" size="medium" />
                        </Link>
                    }
                    userName={auth.nameUser}
                    isAllowed={auth.settingTrue}
                    isAuthenticated={auth.authenticated}
                    privateElements={
                        <>
                            <Link to="/ixyber/vision/display/settingmain" title="Настройки">
                                <IconButton imageUrl="Setting" size="medium" />
                            </Link>
                            <Link to="/ixyber/vision/display/EditorVision" title="Редактор">
                                <IconButton imageUrl="Editor" size="medium" />
                            </Link>
                        </>
                    }
                    callbackLogin={() => {
                        auth.callbackLogin();
                    }}
                    callbackLogout={() => {
                        auth.callbackLogout();
                    }}></Header>
                <div style={{ height: 'calc(100% - 7em)', display: 'flex' }}>
                    <Card style={{ minWidth: '14em', width: widthWindowTree + 'px' }}>
                        <div style={{ paddingRight: '2em' }}>
                            <TreeAPC inpArr={treeBranch} />
                        </div>
                    </Card>
                    <div
                        style={{
                            background: '#fff',
                            width: '0.5em',
                            maxWidth: '0.5em',
                            cursor: 'col-resize'
                        }}
                        onMouseDown={(e) => {
                            setResizeTree(true);
                        }}></div>
                    <Card style={{ width: '100%' }}>{renderPage()}</Card>
                </div>
            </Wrapper>
            <Modal
                children={
                    contextMenu.visible && (
                        <ContextMenu
                            position={contextMenu.position}
                            children={contextMenu.elements}
                            closeCM={() => {
                                setContextMenu(defContextMenu);
                            }}
                        />
                    )
                }
            />
        </React.Fragment>
    );
};

export default observer(Configuration);

//<Reports startFilterName={'fromValue'} startFilterVal={'OFF'} filterListCol={['userID']} />
